<template>
  <div ref="host" class="w-full h-full"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { globalState } from '@/globalState';

const host = ref(null);
const route = useRoute();

onMounted(() => {
  const agentId = route.params.agentid;
  const api = globalState.apiEndpoint;
  if (host.value !== null && agentId !== undefined && agentId !== null && agentId !== '' && api !== undefined && api !== null && api !== '') {
    const s = document.createElement('script');
    s.src = '/publicAgentSnippet/publicChatAgent.js';
    s.setAttribute('data-agent-id', String(agentId));
    s.setAttribute('data-api-endpoint', String(api));
    s.setAttribute('data-target-element', 'body');
    s.setAttribute('data-open-on-load', 'false');
    s.defer = true;
    document.body.appendChild(s);
    let checks = 0;
    const iv = setInterval(() => {
      checks = checks + 1;
      if (window.WebsiteAiStyle !== undefined && window.WebsiteAiStyle !== null && typeof window.WebsiteAiStyle.showPanel === 'function') {
        window.WebsiteAiStyle.showPanel();
        clearInterval(iv);
      } else if (checks >= 60) {
        clearInterval(iv);
      }
    }, 250);
  }
});
</script>

<style scoped>
.w-full { width: 100%; }
.h-full { height: 100%; }
</style>


